export type PillVariant =
  | 'warm'
  | 'blue'
  | 'green'
  | 'gray'
  | 'red'
  | 'purple';

/** 设计稿顺序：4 行 × 6 列，共 24 个 */
export const CHECK_IN_EMOTIONS: { tag: string; variant: PillVariant }[] = [
  { tag: 'Loving', variant: 'warm' },
  { tag: 'Excited', variant: 'warm' },
  { tag: 'Grateful', variant: 'green' },
  { tag: 'Tired', variant: 'gray' },
  { tag: 'Overwhelmed', variant: 'red' },
  { tag: 'Annoyed', variant: 'red' },
  { tag: 'Happy', variant: 'warm' },
  { tag: 'Proud', variant: 'warm' },
  { tag: 'Optimistic', variant: 'green' },
  { tag: 'Numb', variant: 'gray' },
  { tag: 'Anxious', variant: 'red' },
  { tag: 'Frustrated', variant: 'red' },
  { tag: 'Confident', variant: 'warm' },
  { tag: 'Joyful', variant: 'warm' },
  { tag: 'Calm', variant: 'green' },
  { tag: 'Bored', variant: 'gray' },
  { tag: 'Angry', variant: 'red' },
  { tag: 'Stressed', variant: 'red' },
  { tag: 'Sad', variant: 'blue' },
  { tag: 'Guilty', variant: 'blue' },
  { tag: 'Ashamed', variant: 'blue' },
  { tag: 'Okay', variant: 'gray' },
  { tag: 'Insecure', variant: 'purple' },
  { tag: 'Afraid', variant: 'purple' },
];

export const moodPillVariantClass: Record<PillVariant, string> = {
  warm:   'border border-white/20 bg-[#a85d4f]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.22)]',
  blue:   'border border-white/20 bg-[#3d6dad]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]',
  green:  'border border-white/20 bg-[#2f7d5c]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]',
  gray:   'border border-white/20 bg-[#5c6575]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]',
  red:    'border border-white/20 bg-[#8f2d3a]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.15)]',
  purple: 'border border-white/20 bg-[#6a4a78]/95 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.18)]',
};

export function moodVariantForTag(tag: string): PillVariant | null {
  return CHECK_IN_EMOTIONS.find((e) => e.tag === tag)?.variant ?? null;
}
